<template>
  <v-avatar :class="{loading}" :color="fill ? (dark ? 'fin-color-primary-dark' : 'fin-color-primary-light') : undefined"
            :size="size">
    <svg :class="{dark: dark && !fill || !dark && fill}" height="36mm" viewBox="0 0 102.0472 102.0473" width="36mm"
         xmlns="http://www.w3.org/2000/svg">
      <g id="Superzeichen">
        <g>
          <path class="fin-color-accent-red--fill"
                d="M40.4928,69.364l-3.5864,6.2116A28.2166,28.2166,0,0,0,51.0817,79.37V72.1984A21.0776,21.0776,0,0,1,40.4928,69.364Z"/>
          <path class="fin-color-primary-light--fill"
                d="M51.0817,72.1984V79.37A28.3346,28.3346,0,0,0,75.6339,65.1987l-6.2117-3.5862A21.1662,21.1662,0,0,1,51.0817,72.1984Z"/>
          <path class="fin-color-primary-light--fill"
                d="M69.4227,40.4355l6.2114-3.5864A28.3334,28.3334,0,0,0,51.0817,22.6772v7.1716A21.1659,21.1659,0,0,1,69.4227,40.4355Z"/>
          <path class="fin-color-primary-light--fill"
                d="M29.9068,51.0236a21.0761,21.0761,0,0,1,2.8343-10.5888L26.53,36.8483A28.3609,28.3609,0,0,0,36.9064,75.5756l3.5864-6.2116A21.1667,21.1667,0,0,1,29.9068,51.0236Z"/>
          <path class="fin-color-accent-green--fill"
                d="M51.0817,29.8488V22.6772A28.3344,28.3344,0,0,0,26.53,36.8483l6.2115,3.5865A21.1662,21.1662,0,0,1,51.0817,29.8488Z"/>
        </g>
        <path class="fin-color-primary-light--fill"
              d="M51.0236,0a51.0237,51.0237,0,1,0,51.0236,51.0236A51.0236,51.0236,0,0,0,51.0236,0Zm0,4.782A46.2416,46.2416,0,1,1,4.782,51.0236,46.294,46.294,0,0,1,51.0236,4.782"
              v-if="border"/>
      </g>
    </svg>

  </v-avatar>
</template>

<script>
export default {
  name: 'finLogoSign',
  props: {
    /** Shows the logo with a border. */
    border: {
      type: Boolean,
      default: false
    },
    /** Sets the logo to the filled state. */
    fill: {
      type: Boolean,
      default: false
    },
    /** Sets the dark mode. */
    dark: {
      type: Boolean,
      default: false
    },
    /** Sets the component to the loading state. */
    loading: {
      type: Boolean,
      default: false
    },
    /** Sets the height and width of the component. */
    size: {
      type: [Number, String],
      default: 36
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/main";

  .loading {
    animation: rotation 8s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>
